<template>
    <tr
        v-if="!isBeingEdited"
        class="kgr-table__row"
    >
        <td class="kgr-table__cell">
            {{ role.parameterValue.value }}
        </td>
        <td class="kgr-table__cell">
            {{ role.from }}
        </td>
        <td class="kgr-table__cell">
            {{ role.to }}
        </td>
        <td class="kgr-table__cell">
            {{ departmentName }}
        </td>
        <td class="kgr-table__cell">
            {{ teamName }}
        </td>
        <td class="kgr-table__cell notice">
            <p
                v-for="(noticeLine, index) in notice"
                :key="index"
            >
                {{ noticeLine }}
            </p>
        </td>
        <td class="kgr-table__cell kgr-table__cell--actions">
            <kgr-icon-edit
                v-if="role.isEditable"
                :size="15"
                class="kgr-table__action"
                @click="$emit('edit')"
            />
            <kgr-icon-delete
                v-if="role.isDeletable"
                class="kgr-table__action"
                @click="$emit('remove')"
            />
        </td>
    </tr>
</template>

<script setup>
import ClubEmployeeRole from '../../../js/dto/ClubEmployeeRole';
import KgrIconDelete from '../../common/icon/IconDelete';
import KgrIconEdit from '../../common/icon/IconEdit';
import { computed } from 'vue';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps({
    role: {
        type: ClubEmployeeRole,
        required: true,
    },
    editRoles: {
        type: Array,
        required: true,
    },
});

defineEmits(['edit', 'remove']);

const isBeingEdited = computed(() => props.editRoles.map(editRole => editRole.id).indexOf(props.role.id) !== -1);
const notice = computed(() => (props.role.notice === null ? [] : props.role.notice.split('\n')));
const departmentName = computed(() => (props.role.department ? props.role.department.extendedName() : ''));
const teamName = computed(() => (props.role.team ? props.role.team.extendedName() : ''));
</script>
